import axios from "axios";

import { getApiEndpoint } from "./helpers";
const axiosClient = axios.create({
    baseURL: getApiEndpoint(),
});
export { axiosClient };
